import { createActionTypes } from "../create_action_types";

export function createReducer(fieldName, defaultValue) {
  const actionTypes = createActionTypes(fieldName);

  return (state = defaultValue, action) => {
    switch (action.type) {
      case actionTypes.setValuesForKeys: {
        return action.payload;
      }

      default:
        return state;
    }
  };
}
